import { observable, action } from 'mobx';
import { checkIfCustomer, IS_NATIVE_APP_CLIENT } from 'src/scripts/utils/helpers';
import { GatedSaleConfigurations, IGatedSaleState } from './types';

export const gatedSaleState: IGatedSaleState = observable({
  // Initial state
  memberGatedSaleConfig: {
    isEnabled: false,
    priceAppendix: '',
    textColor: '',
    memberGatedBadgeColor: '',
  },
  appGatedSaleConfig: {
    isEnabled: false,
    textColor: '',
    priceAppendix: '',
  },
  hardMarkSaleConfig: {
    isEnabled: false,
    badgeCopy: '',
    saleColor: '',
  },
  isConfigFetched: false,
  potentialSavingsCopy: '',
  suppressBadgeTags: false,

  get getGatedSaleVisibilityConfig() {
    const isLoggedIn = checkIfCustomer();
    const { appGatedSaleConfig, memberGatedSaleConfig } = gatedSaleState;
    // App-gated sale
    if (appGatedSaleConfig.isEnabled) {
      return {
        shouldShowMemberDiscountBadge: false,
        shouldShowGatedSalePricing: !IS_NATIVE_APP_CLIENT,
      };
    }
    // Member-gated sale
    if (memberGatedSaleConfig.isEnabled) {
      return {
        shouldShowMemberDiscountBadge: isLoggedIn,
        shouldShowGatedSalePricing: !isLoggedIn,
      };
    }
    return { shouldShowMemberDiscountBadge: false, shouldShowGatedSalePricing: false };
  },

  setGatedSaleState: action(async function (data: GatedSaleConfigurations) {
    const { membersExclusive, appOnlySale, hardMarkSale, potentialSavingsCopy, suppressBadgeTags } = data;

    gatedSaleState.memberGatedSaleConfig = {
      isEnabled: membersExclusive?.membersExclusiveEnabled || false,
      priceAppendix: membersExclusive?.guestUserDiscountCopy || '',
      textColor: membersExclusive?.guestUserDiscountCopyColor || '',
      memberGatedBadgeColor: membersExclusive?.memberBadgeColor || '',
    };
    gatedSaleState.appGatedSaleConfig = {
      isEnabled: appOnlySale?.appOnlySaleEnabled || false,
      textColor: appOnlySale?.appOnlySaleDiscountCopyColor || '',
      priceAppendix: appOnlySale?.appOnlySaleDiscountCopy || '',
    };
    gatedSaleState.hardMarkSaleConfig = {
      isEnabled: hardMarkSale?.hardMarkSaleEnabled || false,
      badgeCopy: hardMarkSale?.hardMarkSaleBadgeCopy || '',
      saleColor: hardMarkSale?.hardMarkSaleColor || '',
    };
    gatedSaleState.isConfigFetched = true;
    gatedSaleState.potentialSavingsCopy = potentialSavingsCopy || '';
    gatedSaleState.suppressBadgeTags = suppressBadgeTags || false;
  }),
});
